import { DefaultPalette, mergeStyles } from '@fluentui/react';

export const toolbarWrapper = mergeStyles({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  alignItems: 'flex-end',
});

export const personaDetailsWrapper = mergeStyles({
  backgroundColor: DefaultPalette.neutralLight,
  flexGrow: 1,
  padding: 5,
});

const sideBysideFormChildrenGap = 20;
const userDetailStackChildrenGap = 25;
export const sideBySideFormFieldsClassName = mergeStyles({
  width: `calc(50% - ${sideBysideFormChildrenGap}px)`,
});
export const sideBySideWrapper = {
  childrenGap: sideBysideFormChildrenGap,
  padding: '20px 0',
};
export const userDetailsStack = { childrenGap: userDetailStackChildrenGap };
